/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PersonPaymentAccount/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function PersonPaymentAccount({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreatePaymentPlanForExistingInvoice/Content/Content/SourceInvoice/PaymentAccount/PersonPaymentAccount"
  
}) {
let constantData = 'Invoice #'
let receivableHumanReadableIdValueData = fromData.useDataValue({ viewPath,
context: 'receivable',
path: 'human_readable_id',
})
let constantData1 = ' - Payor: '
let receivablePaymentAccountPersonPaymentAccountPayerPersonValueData = fromData.useDataFormat({ viewPath,
context: 'receivable',
path: 'payment_account.person_payment_account.payer_person',
format: fromFormat.personName,
})
let aggregateData = fromAggregate.joinNoSpace(constantData, receivableHumanReadableIdValueData, constantData1, receivablePaymentAccountPersonPaymentAccountPayerPersonValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="'Invoice #'"
 data="receivable.human_readable_id"
 aggregate="/Data/aggregate.js joinNoSpace"
 data="' - Payor: '"
 data="receivable.payment_account.person_payment_account.payer_person"
 format="/Data/format.js personName"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}